import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';

import { auth } from '../../../app/firebase';
import AdminDevServices from './adminDevServices';

export default function AdminDevServicesContainer() {
  const [checkingAdmin, setCheckingAdmin] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setCheckingAdmin(true);
      setIsAdmin(false);
      if (!user) {
        setCheckingAdmin(false);
        return;
      }
      try {
        const token = await user.getIdTokenResult(true);
        setIsAdmin(!!token.claims.admin);
      } finally {
        setCheckingAdmin(false);
      }
    });
    return () => unsub();
  }, []);

  if (checkingAdmin) return <div style={{ padding: 16 }}>Checking admin rights…</div>;
  if (!isAdmin) return <div style={{ padding: 16 }}>403 — Admin access only</div>;

  return <AdminDevServices />;
}
